export default __webpack_public_path__ + "static/media/polkadot-js.7d2701e2.svg";